import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import './ProductStatistics.css';
import { Period } from '../../model/Period';
import PieChart from '../PieChart/PieChart';
import { useProductStatistics } from '../../hooks/useProductStatistics';
import PeriodCard from '../PeriodCard/PeriodCard';
import PayoutSellerStatistics from '../PayoutStatistics/Sellers/PayoutSellerStatistics';
import LatestPayoutStatistics from '../PayoutStatistics/Latest/LatestPayoutStatistics';
import PayoutCountryStatistics from '../PayoutStatistics/Countries/PayoutCountryStatistics';
import { Empty } from "antd";
const ProductStatistics = (props) => {
    const statistics = useProductStatistics(props.product);
    const renderEmptyStatistics = () => (_jsx(Empty, { description: "No payouts yet!" }));
    const renderStatistics = (productStatistics, period) => (_jsxs(_Fragment, { children: [!productStatistics.latestPayouts.length ?
                renderEmptyStatistics() :
                _jsxs(_Fragment, { children: [_jsx(PayoutSellerStatistics, { statistics: productStatistics.topSellers }), _jsx(PayoutCountryStatistics, { statistics: productStatistics.payoutCountries }), period !== Period.Today ?
                            renderCountryPayoutsChart(productStatistics.payoutCountries) :
                            null] }), period === Period.Today ?
                _jsx(LatestPayoutStatistics, { statistics: statistics.month.latestPayouts }) :
                null] }));
    const renderPeriodCard = (period) => (_jsx(PeriodCard, { period: period, children: renderStatistics(statistics[period], period) }));
    const renderCountryPayoutsChart = (payouts) => {
        var _a;
        return (_jsx(PieChart, { data: payouts, valueKey: (_a = payouts[0]) === null || _a === void 0 ? void 0 : _a.orderBy[0], labelKey: "country", formatLabel: p => `Motty ${p.country}` }));
    };
    return (_jsxs("div", { className: "product-statistics", children: [renderPeriodCard(Period.Week), renderPeriodCard(Period.Today), renderPeriodCard(Period.Month)] }));
};
export default ProductStatistics;
